<div class="flex flex-col h-full w-full gap-3 px-3 overflow-hidden ">
    <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-2">
        <div class="flex items-center  w-full gap-2"> <!-- min-w-0 ensures flex children can shrink -->
            <i class="pi pi-chevron-left cursor-pointer text-lg sm:text-xl" (click)="goBack()"></i>
            <div class="w-full flex justify-between items-end gap-2">
                <p-tabs [value]="selectedTabIndex().toString()" (valueChange)="handleTabChange($event)"
                    class="custom-tabview w-full">
                    <p-tablist>
                        @for(tab of createDocumentDialogTabs();let i = $index; track tab.id) {
                        <p-tab [value]="i.toString()" [disabled]="tab.disabled" [pTooltip]="tab.tooltip || ''"
                            [tooltipPosition]="'top'" [showDelay]="300" class="flex items-center !gap-2">
                            <div class="flex items-center gap-2">
                                <span class="font-sans text-sm whitespace-nowrap"
                                    [ngClass]="{'text-blue-700': selectedTabIndex() === i}">{{
                                    tab.label
                                    }}</span>
                            </div>
                        </p-tab>
                        }
                    </p-tablist>
                </p-tabs>
                <div class="flex items-end h-full">
                    <app-menu #optionsMenu [items]="optionsMenuItems" (itemSelected)="onOptionSelect($event)"
                        (visibleChange)="isOptionsMenuOpen = $event" [pTooltip]="'Options'" tooltipPosition="top">
                        <app-button (clicked)="openOptionsPanel($event)" variant="outlined" severity="contrast"
                            icon="pi pi-ellipsis-v" class="text-xs sm:text-sm flex-1 sm:flex-initial" />
                    </app-menu>
                </div>
            </div>
        </div>
        <!-- <div class="flex items-center gap-2 flex-shrink-0 flex-wrap w-full sm:w-auto justify-start sm:justify-end">
            @if (project && canEditProject) {
            <app-button variant="outlined" severity="contrast" label="Edit" icon="pi pi-pencil"
                (clicked)="openProjectDialog()" *ngIf="canEdit" [disabled]="!project.active"
                class="text-xs sm:text-sm flex-1 sm:flex-initial" />
            }
            @if(!isActive) {
            <app-button variant="outlined" severity="contrast" label="Restore Project" icon="pi pi-undo"
                (clicked)="openRestoreDialog()" *ngIf="isAdmin || isOwner"
                class="text-xs sm:text-sm flex-1 sm:flex-initial" />
            }
            <app-button variant="outlined" severity="danger"
                [label]="isActive ? 'Delete Project' : 'Delete Project Permanently'" icon="pi pi-trash"
                (clicked)="openDeleteDialog()" *ngIf="canDeleteProject"
                class="text-xs sm:text-sm flex-1 sm:flex-initial" />
        </div> -->
    </div>

    <!-- Main Grid Container -->
    <div class="dashboard-grid flex flex-col gap-3 md:gap-2 h-full overflow-scroll">
        @if(selectedTabIndex() === 0){
        @if(project){
        <app-project-document #projectDocumentComponent [projectId]="projectId" [permissions]="permissions"
            [isOwner]="isOwner" [isManager]="isManager" [currentRole]="currentRole" class="overflow-hidden"
            [projectActive]="project.active" [projectDueDate]="getProjectDueDate()" [selectedMetric]="selectedMetric"
            (documentsDeleted)="onProjectDocumentsDeleted()" (documentDueDateUpdated)="getDocumentMetrics()">
        </app-project-document>
        }
        }@else if(selectedTabIndex() === 1){
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
            @if(isLoadingMetrics) {
            @for(i of [1,2,3,4]; track i) {
            <div class="px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-base text-center">
                <p-skeleton width="100%" height="1rem" class="mb-2"></p-skeleton>
                <p-skeleton width="50%" height="2rem"></p-skeleton>
            </div>
            }
            }@else {
            @for(metric of documentMetricsData;track metric){
            <div class="flex flex-col sm:flex-row items-center justify-between px-3 sm:px-4 py-1 sm:py-1 border border-gray-300 rounded-xl hover:border-arena-orange-400 cursor-pointer transition-colors"
                [ngClass]="selectedMetric?.label === metric.label ? 'border-arena-orange-400 bg-arena-orange-50' : ''"
                (click)="selectMetric(metric)">
                <div class="text-slate-500 text-sm sm:text-base font-medium mb-1 sm:mb-0">
                    {{metric.label}}
                </div>
                <div class="text-md sm:text-2xl font-medium">
                    {{metric.value}}
                </div>
            </div>
            }
            }
        </div>

        <div class="flex justify-between gap-2">
            <div class="border rounded-xl p-3 w-[30%]" step-id="project-dashboard-step2">
                <div class="text-xl font-semibold">Details</div>
                <div class="grid grid-cols-2 gap-2 py-2 mt-2">
                    <div class="text-sm font-medium flex items-center gap-x-2 p-1 text-gray-400">
                        <app-icon [type]="projectDetailsIcons().AlignLeft" size="sm" source="lucide"
                            class="text-gray-400"></app-icon>
                        <div class="text-sm font-medium truncate">Project name</div>
                    </div>
                    <div class="text-sm font-medium flex items-center gap-x-2">
                        <div class="text-sm font-medium truncate">{{project.name}}</div>
                    </div>
                    <div class="text-sm font-medium flex items-center p-1 gap-x-2 text-gray-400">
                        <app-icon [type]="projectDetailsIcons().SquareUserRound" size="sm" source="lucide"
                            class="text-gray-400"></app-icon>
                        <div class="text-sm font-medium truncate">Project manager</div>
                    </div>
                    <div class="text-sm font-medium flex items-center  gap-x-2">
                        <div class="text-sm font-medium truncate"><app-avatar-stack [users]="projectManagerUsers"
                                [visibleAvatars]="2" size="xs">
                            </app-avatar-stack></div>
                    </div>
                    <div class="text-sm font-medium flex items-center p-1 gap-x-2 text-gray-400">
                        <app-icon [type]="projectDetailsIcons().Users" size="sm" source="lucide"
                            class="text-gray-400"></app-icon>
                        <div class="text-sm font-medium truncate">Customer / prospect</div>
                    </div>
                    <div class="text-sm font-medium flex items-center  gap-x-2">
                        <div class="text-sm font-medium truncate">{{getCustomerName(project.customer)}}</div>
                    </div>
                    <div class="text-sm font-medium flex items-center p-1 gap-x-2 text-gray-400">
                        <app-icon [type]="projectDetailsIcons().Calendar1" size="sm" source="lucide"
                            class="text-gray-400"></app-icon>
                        <div class="text-sm font-medium">Created at</div>
                    </div>
                    <div class="text-sm font-medium flex items-center  gap-x-2">
                        <div class="text-sm font-medium truncate">{{project.createdAt | date:'MMM d, y'}}</div>
                    </div>
                    <div class="text-sm font-medium flex items-center p-1 gap-x-2 text-gray-400">
                        <app-icon [type]="projectDetailsIcons().Hourglass" size="sm" source="lucide"
                            class="text-gray-400"></app-icon>
                        <div class="text-sm font-medium truncate">Due date</div>
                    </div>
                    <div class="text-sm font-medium flex items-center  gap-x-2">
                        <div class="text-sm font-medium truncate">
                            {{
                            project.dueDate
                            ?
                            (project.dueDate | date:'MMM d,y') : '-'
                            }}
                        </div>
                    </div>
                    <div class="text-sm font-medium flex items-center p-1 gap-x-2 text-gray-400">
                        <app-icon [type]="projectDetailsIcons().Flame" size="sm" source="lucide"
                            class="text-gray-400"></app-icon>
                        <div class="text-sm font-medium truncate">Status</div>
                    </div>
                    <div class="text-sm font-medium flex items-center  gap-x-2">
                        <div class="relative text-sm font-medium truncate">
                            <app-select [options]="statusOptions" [value]="selectedStatus?._id"
                                [config]="statusSelectConfig" [optionLabel]="'label'" [optionValue]="'value'"
                                (onChange)="onStatusChange($event)">
                            </app-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="border rounded-xl p-3 w-[70%]" step-id="project-dashboard-step3">
                <div class="flex justify-between items-center">
                    <div class="text-lg font-semibold">People tracker</div>
                    <div class="flex justify-end mb-2">
                        <app-button variant="outlined" severity="contrast" icon="pi pi-send" label="Send Reminder"
                            (clicked)="openReminderDialog()" class="panel-toggle-icon"
                            [disabled]="selectedAssigneeUsers.length==0 || !project.active"
                            *ngIf="isAdmin || isOwner || isManager || permissions.canEdit" />
                    </div>
                </div>
                <div class="flex flex-col overflow-hidden">
                    <div class="flex-1 min-h-0">
                        @if(isLoadingPeopleTracker) {
                        <div class="flex flex-col gap-4 p-3">
                            @for(i of [1,2,3,4]; track i) {
                            <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                            }
                        </div>
                        }@else {
                        <app-data-table [data]="projectPeople" [columns]="tableColumns" [config]="currentTableConfig"
                            [customEmptyTemplate]="noAssigneesTemplate" [dataKey]="'user._id'"
                            (selectionChange)="onSelectionChange($event)" [customTemplates]="templatesMap">
                        </app-data-table>
                        <ng-template #noAssigneesTemplate>
                            <div class="flex flex-col items-center justify-center h-full">
                                <i [innerHTML]="PROJECT_DASHBOARD_SVG.EMPTY_STATE_ASSIGNEE | sanitizeHtml"
                                    alt="No Assignees"> </i>
                                <span class="text-sm text-gray-500">Assignee data will be shown here</span>
                            </div>
                        </ng-template>
                        }
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-between gap-2 pb-3 h-full overflow-hidden min-h-[30%]">
            <div class="border rounded-xl p-3 w-[33%]" step-id="project-dashboard-step4">
                <div class="flex justify-between items-center">
                    <div class="text-lg font-semibold">Milestones</div>
                    <div class="flex justify-end mb-2" step-id="project-dashboard-step5">
                        @if(canAddMilestone() && project){
                        <app-button variant="outlined" severity="contrast" icon="pi pi-plus"
                            (clicked)="openMilestoneDialog()" [disabled]="!project.active" class="flex-shrink-0" />
                        }
                    </div>
                </div>
                <div class="flex flex-col w-full flex-1 h-[85%] overflow-scroll">
                    @if(isLoadingMilestones) {
                    <div class="flex flex-col gap-2 mt-2 sm:mt-4 px-2 sm:px-0">
                        @for(i of [1,2,3,4]; track i) {
                        <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                        }
                    </div>
                    }@else if(project) {
                    @if(sortedMilestones.length > 0) {
                    <div #milestonesScrollContainer class="flex flex-col gap-2 text-xs sm:text-sm text-gray-700">
                        @for(milestone of sortedMilestones;track milestone._id){
                        <div class="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <i class="pi pi-verified text-sm sm:text-base"
                                [ngClass]="checkDueDatePassed(milestone.date) ? 'text-success' : ''"></i>
                            <div class="">
                                <span class="text-md font-semibold truncate" [pTooltip]="milestone.name"
                                    tooltipPosition="bottom">{{ milestone.name
                                    }}</span>
                                <div class="text-xs text-gray-500"> On {{ milestone.date | date: 'd MMM, y'}}</div>
                            </div>
                        </div>
                        }
                    </div>
                    }@else {
                    <div class="flex flex-col items-center justify-center h-full">
                        <app-icon [type]="PROJECT_DASHBOARD_SVG.EMPTY_MILESTONES" source="svg" size="sm"
                            class="text-gray-500"></app-icon>
                        <span class="text-sm text-gray-500">Milestones will be shown here</span>
                    </div>
                    }
                    }
                </div>
            </div>

            <div class="border rounded-xl p-3 w-[33%]" step-id="project-dashboard-step6">
                <div class="text-lg font-semibold">History</div>
                <div class="flex flex-col w-full h-full flex-1 min-h-0 overflow-hidden">
                    @if(project){
                    <div class="flex-1 min-h-0 flex flex-col overflow-hidden">
                        <div #historyScrollContainer
                            class="flex-1 min-h-0 flex flex-col gap-2 text-xs sm:text-sm text-gray-700 mt-2 sm:mt-4 overflow-auto scroll-smooth">
                            <app-history-tab class=" h-full w-full" [auditModule]="AUDIT_MODULE.PROJECTS" [filter]="{
                                        projectId: projectId
                                    }"></app-history-tab>
                        </div>
                    </div>
                    }
                </div>
            </div>

            <div class="border rounded-xl p-3 w-[33%] flex flex-col h-full overflow-hidden" step-id="project-dashboard-step7">
                <div class="flex justify-between items-center mb-2">
                    <div class="text-lg font-semibold truncate" [pTooltip]="'Project knowledge'">Project knowledge</div>
                    <div class="flex justify-end gap-2 flex-shrink-0">
                        <app-button variant="outlined" severity="contrast" icon="pi pi-upload" iconPosition="left"
                            (clicked)="uploadProjectKnowledgeFile()"
                            [disabled]="!project.active || !canAccessProjectKnowledge()" />
                        <app-button variant="filled" variant="outlined" severity="contrast" icon="pi pi-eye"
                            (clicked)="navigateToProjectKnowledge()"
                            [disabled]="!project.active || !canAccessProjectKnowledge()" />
                    </div>
                </div>
                <div class="flex-1 min-h-0 overflow-y-auto">
                    @if(isLoadingProjectKnowledgeFiles) {
                    <div class="flex items-center justify-center h-full">
                        <p-skeleton width="100%" height="3rem" class="mb-2"></p-skeleton>
                    </div>
                    } @else if(projectKnowledgeFiles.length === 0) {
                    <div class="flex flex-col items-center justify-center h-full text-gray-500 text-sm">
                        <span class="text-sm text-gray-500">Project knowledge files will be shown here</span>
                    </div>
                    } @else {
                    <div class="flex flex-col gap-0">
                        @for(file of projectKnowledgeFiles; track file._id) {
                        <div class="flex items-start gap-3 py-3 border-b border-gray-200 last:border-b-0">
                            <div class="flex-shrink-0 w-7 h-7 flex items-center justify-center">
                                @if(file.mimeType === 'pdf') {
                                <i [innerHTML]="SVGS().PDF | sanitizeHtml" class="w-full h-full"></i>
                                } @else if(file.mimeType == "docx"){
                                <i [innerHTML]="SVGS().DOCX | sanitizeHtml"></i>
                                }
                            </div>
                            <div class="flex-1 min-w-0">
                                <div class="font-semibold text-sm text-gray-900 truncate" [pTooltip]="file.name">
                                    {{ file.name }}
                                </div>
                                <div class="text-xs text-gray-500 mt-1">
                                    {{ formatFileDate(file.createdAt) }}
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>
        </div>
        }
        @else if(selectedTabIndex() === 2){
        <app-tasks [projectId]="projectId"></app-tasks>
        }
    </div>
</div>

<app-project-form-dialog [(visible)]="projectDialogVisible" [mode]="'edit'" [projectFormData]="projectFormData"
    [managerOptions]="managerOptions" [projectId]="projectId" [permissions]="permissions"
    (submit)="updateProjectFromDialog($event)" (hide)="resetProjectDialog()"
    [shareDetails]="shareDetails"></app-project-form-dialog>

<!-- Reminder Dialog -->
<app-dialog [(visible)]="displayReminderDialog" title="Send Reminder" (closed)="resetReminderForm()"
    class="max-w-[40rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="p-4">
            <p class="mb-3 sm:mb-4 text-xs sm:text-sm text-gray-600">
                Assignees will get a notification through their emails summarizing the questions needing
                assistance.
            </p>

            <!-- Chips for selected users -->
            <div class="mb-3 sm:mb-4 flex flex-wrap gap-2">
                <p-chip *ngFor="let user of selectedAssigneeUsers" [label]="user.fullName" [removable]="true"
                    (onRemove)="assigneeSelect(user)" class="flex-shrink-0 text-xs sm:text-sm"></p-chip>
            </div>

            <!-- Message textarea -->
            <div class="mb-3 sm:mb-4">
                <label for="reminderMsg" class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                    Message <span class="text-danger">*</span>
                </label>
                <textarea id="reminderMsg" [(ngModel)]="assigneeReminderMessage" rows="5"
                    class="w-full border border-gray-300 rounded p-2 text-xs sm:text-sm focus:outline-none focus:ring-2 focus:ring-arena-orange"
                    placeholder="Hi, hope you are doing well. This is to remind you that…"></textarea>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex flex-col sm:flex-row justify-end gap-2">
            <app-button variant="outlined" severity="contrast" label="Cancel" (clicked)="resetReminderForm()"
                class="text-xs sm:text-sm w-full sm:w-auto" />
            <app-button variant="filled" severity="primary" icon="pi pi-send" label="Send Reminder"
                (clicked)="sendReminderToSelectedAssignees()"
                [disabled]="selectedAssigneeUsers.length==0 || assigneeReminderMessage.length==0"
                class="text-xs sm:text-sm w-full sm:w-auto" />
        </div>
    </ng-template>
</app-dialog>

@if(displayDeleteDialog && project){
<app-delete-confirmation [(visible)]="displayDeleteDialog" confirmButtonText="Yes, delete" [requireConfirmation]="true"
    [headerText]="'Delete ' + project.name + ' ' + (isActive ? 'Project' : 'Project Permanently') + ' ?'"
    [bodyText]="'Deleting this project will ' + (isActive ? 'archive' : 'permanently delete') + ' all associated project documents and project knowledge.'"
    (onConfirm)="confirmDeleteProject()" [closable]="false">
    <ng-template #zipDownloadTemplate>
        <div class="flex flex-col font-semibold sm:flex-row sm:items-center sm:justify-between gap-3 py-2">
            <p class="text-sm text-gray-700">Download ZIP containing project documents and project knowledge</p>
            <app-button variant="outlined" severity="contrast" label="Download ZIP" (clicked)="downloadZIP()"
                [loading]="isDownloadingZIP" class="w-full sm:w-auto flex-shrink-0" />
        </div>
    </ng-template>
</app-delete-confirmation>
}


@if(displayRestoreDialog && project) {
<app-delete-confirmation [(visible)]="displayRestoreDialog" width="28rem" confirmButtonText="Yes, restore"
    [requireConfirmation]="true" [confirmationText]="'restore'" (onConfirm)="restoreProject()">
    <ng-template #headerTemplate>
        <div class="flex items-center min-w-0">
            <i class="pi pi-undo text-success text-2xl mr-2 flex-shrink-0"></i>
            <h2 class="text-lg font-semibold truncate max-w-[18.75rem]"
                [title]="'Restore ' + project.name + ' Project?'">
                Restore {{ project.name }} Project ?
            </h2>
        </div>
    </ng-template>

    <ng-template #bodyTemplate>
        <p class="text-sm text-gray-700">
            The project and the data associated with it will be restored.
        </p>
    </ng-template>
</app-delete-confirmation>
}

<!-- Data Table Templates -->
<!-- Name Template -->
<ng-template #nameTemplateRef let-assignee="$implicit">
    <app-user-name-display [user]="assignee?.user" />
</ng-template>

<!-- Progress Template -->
<ng-template #progressTemplateRef let-assignee="$implicit">
    <div #barTarget class="relative flex items-center space-x-2"
        (mouseenter)="showProgressOverlay($event, assignee, barTarget)" (mouseleave)="hideProgressOverlay()">
        <div class="relative flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
            <div class="absolute left-0 top-0 h-2 bg-blue-500" [style.width.%]="assignee?.totalProgress">
            </div>
        </div>
        <span class="text-sm font-medium text-gray-800">{{ assignee?.totalProgress }}%</span>
    </div>
</ng-template>

<!-- To Answer Template -->
<ng-template #toAnswerTemplateRef let-assignee="$implicit">
    <span class="text-sm text-gray-800">
        {{getNoOfQuestionsToAnswer(assignee)}}
    </span>
</ng-template>

<!-- To Approve Template -->
<ng-template #toApproveTemplateRef let-assignee="$implicit">
    <span class="text-sm text-gray-800">
        {{getNoOfDocumentsToApprove(assignee)}}
    </span>
</ng-template>



<!-- Last Notified Template -->
<ng-template #lastNotifiedTemplateRef let-assignee="$implicit">
    <span class="text-sm text-gray-600">
        @if(assignee?.lastNotifiedAt) {
        {{ assignee?.lastNotifiedAt | TimeSince }}
        }@else {
        -
        }
    </span>
</ng-template>


<app-dialog [(visible)]="mileStoneDialogVisible" title="Add Milestones" (closed)="mileStoneDialogVisible = false"
    class="max-w-[70vw] h-[90vh]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <app-milestones #milestonesComponent [milestones]="milestones" [maxMilestoneDueDate]="projectFormData.dueDate"
            [permissions]="permissions" (save)="onMilestoneSave($event)" (cancel)="onMilestoneCancel()">
        </app-milestones>
    </ng-template>
</app-dialog>

<app-popover #progressOverlay width="auto" maxHeight="80vh">
    <ng-template #trigger>
        <!-- Trigger is programmatic via show() method -->
    </ng-template>
    <ng-template #body>
        <div class="p-4" (mouseenter)="cancelHideProgressOverlay()" (mouseleave)="hideProgressOverlay()">
            <!-- Questions Section -->
            <div class="mb-4">
                <h4 class="text-sm font-medium text-gray-900 mb-3">Questions</h4>
                <div class="flex flex-col gap-2">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center">
                            <div class="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                            <span class="text-sm text-gray-600">Answered</span>
                        </div>
                        <span class="text-sm font-medium text-gray-900">{{
                            detailAssignee?.questions?.answered
                            || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between">
                        <div class="flex items-center">
                            <div class="w-2 h-2 bg-gray-400 rounded-full mr-2"></div>
                            <span class="text-sm text-gray-600">Unanswered</span>
                        </div>
                        <span class="text-sm font-medium text-gray-900">{{
                            detailAssignee?.questions?.unanswered
                            || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between">
                        <div class="flex items-center">
                            <div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                            <span class="text-sm text-gray-600">Approved</span>
                        </div>
                        <span class="text-sm font-medium text-gray-900">{{
                            detailAssignee?.questions?.approved
                            || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between">
                        <div class="flex items-center">
                            <div class="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                            <span class="text-sm text-gray-600">Rejected</span>
                        </div>
                        <span class="text-sm font-medium text-gray-900">{{
                            detailAssignee?.questions?.rejected
                            || 0 }}</span>
                    </div>
                </div>
            </div>

            <!-- Divider -->
            <div class="border-t border-gray-200 my-4"></div>

            <!-- Documents Section -->
            <div>
                <h4 class="text-sm font-medium text-gray-900 mb-3">Documents</h4>
                <div class="flex flex-col gap-2">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center">
                            <div class="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
                            <span class="text-sm text-gray-600">Pending</span>
                        </div>
                        <span class="text-sm font-medium text-gray-900">{{
                            detailAssignee?.documents?.pending ||
                            0 }}</span>
                    </div>
                    <div class="flex items-center justify-between">
                        <div class="flex items-center">
                            <div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                            <span class="text-sm text-gray-600">Approved</span>
                        </div>
                        <span class="text-sm font-medium text-gray-900">{{
                            detailAssignee?.documents?.approved
                            || 0 }}</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</app-popover>


<app-dialog [(visible)]="workspaceMismatchDialog" title="You're in the Wrong Workspace" [showCloseButton]="false"
    class="max-w-[30rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-4 p-4">
            <p class="text-sm text-gray-600">
                This Project is available in a different workspace. Please switch to the appropriate workspace to
                access it.
            </p>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Switch Workspace" (clicked)="switchToProjectWorkspace()" severity="primary"
                variant="filled" icon="pi pi-sign-out" />
        </div>
    </ng-template>
</app-dialog>
